import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ManagementsUsersComponent } from '../managements-users/managements-users.component';
import { DataSessionService } from '../../../core/services/data-session.service';
import { ManagementsRequestsComponent } from '../managements-request/managements-requests.component';
import { Roles } from '../../../core/types/session-data';
import { SelectData } from '../../shared/type/input';
import { ManagementsService } from '../services/managements.service';
import { SpinnerService } from '../../../core/services/spinner.service';
import { Subscription } from 'rxjs';
import { DataLayerService } from '../../../core/services/data-layer.service';

@Component({
  selector: 'app-managements',
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    ManagementsUsersComponent,
    ManagementsRequestsComponent,
  ],
  providers: [],
  templateUrl: './managements.component.html',
  styleUrl: './managements.component.scss',
})
export class ManagementsComponent implements OnInit, OnDestroy {
  tabSelected!: 'users' | 'requests';
  authRequestListRole: Roles[] = ['responsable_contenido'];
  authUsersListRole: Roles[] = ['administrador'];

  filterContentList: SelectData[] = [];
  filterNameList: SelectData[] = [];
  filterCompanyList: SelectData[] = [];
  subscription: Subscription = new Subscription();

  tabs: { [key: string]: boolean } = {
    users: false,
    requests: false,
  };

  constructor(
    private readonly _dataSessionService: DataSessionService,
    private readonly _managementsService: ManagementsService,
    private readonly _spinnerService: SpinnerService,
    private readonly _dataLayerService: DataLayerService
  ) {
    this.getFiltersRequests();
  }

  ngOnInit(): void {
    this.tabs['users'] = this.showTab('users');
    this.tabs['requests'] = this.showTab('requests');

    this.tabSelected = this.tabs['users']
      ? 'users'
      : this.tabs['requests']
      ? 'requests'
      : 'users';
  }

  selectTab(tab: 'users' | 'requests'): void {
    this.tabSelected = tab;
    // registrar evento en dataLayer
    if (tab === 'users') {
      this._dataLayerService.pushEventClickLink(
        'my-managements-requests',
        'tab-users',
        'Gestión de usuarios',
        'main menu'
      );
    } else if (tab === 'requests') {
      this._dataLayerService.pushEventClickLink(
        'my-managements-users',
        'tab-requests',
        'Gestión de solicitudes',
        'main menu'
      );
    }
    this._dataLayerService.pushEventPageView(`my-managements-${tab}`);
  }

  showTab(tab: 'users' | 'requests'): boolean {
    const roles = {
      users: this.authUsersListRole,
      requests: this.authRequestListRole,
    };

    const isValidRole = this._dataSessionService.isValidRole(roles[tab]);

    if (tab === 'users') {
      this.tabSelected = isValidRole ? 'users' : 'requests';
    }

    return isValidRole;
  }

  getFiltersRequests(): void {
    this._spinnerService.show();
    const sub = this._managementsService.getFiltersRequests().subscribe({
      next: (res) => {
        const response: FiltersResponse = res;

        this.filterContentList = response.contents.map(
          (item: ContentFilter) => ({ value: item.content, label: item.name })
        );
        this.filterNameList = response.users.map((item: UserFilter) => ({
          value: item.email,
          label: item.fullName,
        }));
        this.filterCompanyList = response.companys.map((item: string) => ({
          value: item,
          label: item,
        }));
      },
      error: (err) => {
        this.filterContentList = [];
        this.filterNameList = [];
        this.filterCompanyList = [];
        this._spinnerService.hide();
      },
      complete: () => {
        this._spinnerService.hide();
      },
    });
    this.subscription.add(sub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
